// src/ImageList.js
import React from 'react';
import '../CSS/Home.css';
import DownloadSVG from "../download-solid.svg";
import axios from 'axios';

const ImageList = ({ images }) => {

    const triggerDownload = async (imageUrl) => {
        try {
            // Fetch the image data
            const response = await axios.get(imageUrl, { responseType: 'blob' });

            // Create a blob from the image data
            const blob = new Blob([response.data], { type: response.data.type });

            // Create a link element to initiate the actual download
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'image.jpg';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            console.error('Error triggering download:', error);
        }
    };
    return (
        <div className="imagesBox">
            {images.map((image) => (
                <div key={image.id} className="imagesBoxCard">
                    {/*<a href={image.pageURL} target="_blank" rel="noopener noreferrer">*/}
                        <img src={image.webformatURL} alt={image.tags} className="imagesBoxImage"/>
                    {/*</a>*/}
                    <div className="imageInfo">
                        <p className="imageText">Photo by <a href={`https://pixabay.com/users/${image.user}-${image.user_id}/`} target="_blank" rel="noopener noreferrer">{image.user}</a> on <a href="https://pixabay.com" target="_blank" rel="noopener noreferrer">Pixabay</a></p>
                        <button onClick={() => triggerDownload(image.largeImageURL)} alt={'Download image'}>
                            <img src={DownloadSVG} alt="Download" className="downloadButton"/>
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ImageList;
